<div class="flex flex-column m-b-16">
  <button type="button" mat-raised-button color="warn" (click)="cleanPresentationState(undefined, 'SCREENSHARE')">
    Clear screenshare state
  </button>
</div>
<div class="flex flex-column m-b-16">
  <button type="button" mat-raised-button color="warn" (click)="cleanPresentationState(undefined, 'PRESENTATION')">
    Clear presentation state
  </button>
</div>
<div class="flex flex-column m-b-16">
  <p>
    Please edit the values <strong>before</strong> starting a screenshare. <br />
    Current Bitrate: {{ bitrate }} <br />
  </p>
  <mat-form-field appearance="fill">
    <mat-label>ScreenShare Video Quality</mat-label>
    <mat-select (selectionChange)="onQualityOverride($event.value)" [(value)]="overrideQuality">
      <mat-option [value]="PresenterVideoQuality.QUALITY_STANDARD">Standard</mat-option>
      <mat-option [value]="PresenterVideoQuality.QUALITY_720P">720p</mat-option>
      <mat-option [value]="PresenterVideoQuality.QUALITY_1080P">1080p</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Framerate</mat-label>
    <input title="framerate" type="number" matInput [ngModel]="framerate" (change)="ovverideFramerate()" />
  </mat-form-field>
  <div>
    <mat-label>Audio</mat-label>
    <mat-checkbox [ngModel]="hasAudio" (change)="ovverideAudio()"></mat-checkbox>
  </div>
</div>
